export function AddMonthsToDateString(
  dateString: string,
  incrementValue: number
): string {
  if (!dateString || typeof incrementValue !== 'number') {
    return null;
  }

  const date = new Date(dateString);
  const updatedDate = date.setUTCMonth(date.getUTCMonth() + incrementValue);
  return new Date(updatedDate).toISOString();
}
